import styled from '@emotion/styled'
import { css } from '@emotion/react'
import cn from 'classnames'
import { Tooltip, Flex } from 'shared/ui'
import { twitterHandle } from 'ducks/customers/utils'

const truncate = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const RecipientLabel = styled(({ className, text, type = 'cc' }) => {
  return (
    <div css={truncate} className={cn(className, type)}>
      {text}
    </div>
  )
})`
  color: ${props => props.theme.color.primary.brand};
`

const TruncatedTooltip = ({ tooltip, children }) => {
  return (
    <Tooltip css={truncate} tooltip={tooltip} position="top">
      {children}
    </Tooltip>
  )
}

const Recipient = ({ user }) => {
  const handle = twitterHandle(user)

  if (handle && user.name) {
    return (
      <TruncatedTooltip tooltip={user.name}>
        <RecipientLabel text={handle || user.name} />
      </TruncatedTooltip>
    )
  }

  return <RecipientLabel text={handle || user.name} />
}

const RecipientSummary = ({ className, label = 'To', recipients }) => {
  return (
    <Flex className={cn('grui overflow-hidden', className)}>
      <Flex className="grui overflow-hidden">
        <div className="label">{label}:</div>
        {recipients.map((r, index) => {
          const rid = `twitter-recipient-${index}`
          return (
            <div key={rid} className="grui ml-3 overflow-hidden">
              <Recipient user={r} />
            </div>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default styled(RecipientSummary)`
  .label {
    color: ${props => props.theme.color.monochrome.superDark};
  }
`
